const initialState = {
    modalUploadDownload: false,
}

const uploadDownloadReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'MODAL_UPLOAD_DOWNLOAD':
            return { ...state, modalUploadDownload: action.payload }
        default:
            return state
    }
}

export default uploadDownloadReducer;